import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {omit} from 'lodash';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation createSkillMutation($input: CreateSkillInput!) {
		createSkill(input: $input) {
			skill {
				node {
					id
					name
					category {
						id
					}
					skillPersons {
						person {
							id
							role {
								id
							}
							department {
								id
							}
							active
							permissions
						}
						level {
							id
						}
					}
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.companyId,
			connectionInfo: [
				{
					key: 'Company_skills',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'skill',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		createSkill: {
			skill: {
				node: {
					id: 'new',
					name: input.name,
					category: {
						id: input.categoryId,
					},
					skillPersons: [],
				},
			},
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Skill Created');

	const cleanedInput = omit(input, ['companyId']);

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(cleanedInput),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
